import * as placeholderImgUrl from '../img/Lieferservice-Logo_weiss-transparent_64.png'

export class Image {
	static insert = (src, alt, classes, id, lossless) => {
		//console.log('loading: ', src)
		return `<img ${id ? `id="${id}"` : ''} src="${placeholderImgUrl.default}" alt="${alt}" class="${classes ? classes.join(' ') : ''}" 
			onload="{
				if (this.hasAttribute('preview')) {
					this.removeAttribute('preview')
					this.setAttribute('src', '${src}?width=' + this.offsetWidth + '&height=' + this.offsetHeight + '${lossless ? '&lossless=true' : ''}')
				}
			}"
			onerror="{
				console.log('Failed to load placeholder image from', placeholderImgUrl)
				this.setAttribute('src', 'data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==')
			}"
			preview>`
	}
}